/**
 * @fileoverview Entity Picker cart labeller
 */
goog.declareModuleId('yext.ui.components.entitypicker.cart.cartlabel');

import {CartModel} from '/ui/components/entitypicker/cart/cartmodel';
import {SelectionModel} from '/ui/components/entitypicker/cart/selectionmodel';
import {ItemTypes} from '/ui/components/entitypicker/container/itemtypes';
import {yext} from '/ui/lib/msg';

/**
 * @param {CartModel} cart
 * @param {!Object} options
 * @returns {string} A short string describing the cart's contents
 */
export function cartLabel(cart, {locationsOnly, singleSelect, asFilter, allowedItems, advancedEntityGrouping}) {
  // NOTE(kyu): we default to all itemTypes if none are listed
  const items = allowedItems || [ItemTypes.ENTITIES, ItemTypes.FOLDERS, ItemTypes.LABELS];

  if (cart.hasMultipleTypes()) {
    if (cart.allSelected.length > 0) {
      return yext.msg('Selected Items');
    } else {
      return yext.msgn('1 Item', '{0} Items', cart.total);
    }
  }

  if (cart.allSelected.length === 1) {
    switch (cart.allSelected[0]) {
      case ItemTypes.ENTITIES:
        return locationsOnly ? yext.msg('All Locations') : yext.msg('All Entities');
      case ItemTypes.FOLDERS:
        return yext.msg('All Folders');
      case ItemTypes.LABELS:
        return yext.msg('All Labels');
      case ItemTypes.ENTITYTYPES:
        return yext.msg('All Entity Types');
    }
  }

  if (cart.total === 0) {
    if (advancedEntityGrouping) {
      return yext.msg('Select Entity');
    }

    const entities = items.includes(ItemTypes.ENTITIES);
    const folders = items.includes(ItemTypes.FOLDERS);
    const labels = items.includes(ItemTypes.LABELS);
    const entityTypes = items.includes(ItemTypes.ENTITYTYPES);

    if (singleSelect) {
      switch (true) {
        case items.length >= 3:
          return yext.msg('Select Items');

        case entities && folders && locationsOnly:
          return yext.msg('Select Location or Folder');
        case entities && folders:
          return yext.msg('Select Entity or Folder');
        case folders && labels:
          return yext.msg('Select Folder or Label');
        case entities && labels && locationsOnly:
          return yext.msg('Select Location or Label');
        case entities && labels:
          return yext.msg('Select Entity or Label');
        case entityTypes && folders:
          return yext.msg('Select Entity Type or Folder');
        case entityTypes && labels:
          return yext.msg('Select Entity Type or Label');

        case entities && locationsOnly:
          return yext.msg('Select Location');
        case entities:
          return yext.msg('Select Entity');
        case folders:
          return yext.msg('Select Folder');
        case labels:
          return yext.msg('Select Label');
        case entityTypes:
          return yext.msg('Select Entity Types');
      }
    }

    switch (true) {
      case items.length >= 3:
        // The search bar placeholder displays the full 'Search Entity/Locations, Folders, and Labels'. Using 'Items' here for brevity.
        return asFilter ? yext.msg('All Items') : yext.msg('Select Items');

      case entities && folders && locationsOnly:
        return asFilter
          ? yext.msg('All Locations and Folders')
          : yext.msg('Select Locations or Folders');
      case entities && folders:
        return asFilter
          ? yext.msg('All Entities and Folders')
          : yext.msg('Select Entities or Folders');
      case folders && labels:
        return asFilter
          ? yext.msg('All Folders and Labels')
          : yext.msg('Select Folders or Labels');
      case entities && labels && locationsOnly:
        return asFilter
          ? yext.msg('All Locations and Labels')
          : yext.msg('Select Locations or Labels');
      case entities && labels:
        return asFilter
          ? yext.msg('All Entities and Labels')
          : yext.msg('Select Entities or Labels');
      case entityTypes && folders:
        return asFilter
          ? yext.msg('All Entity Types and Folders')
          : yext.msg('Select Entity Types or Folders');
      case entityTypes && labels:
        return asFilter
          ? yext.msg('All Entity Types and Labels')
          : yext.msg('Select Entity Types or Labels');

      case entities && locationsOnly:
        return asFilter ? yext.msg('All Locations') : yext.msg('Select Locations');
      case entities:
        return asFilter ? yext.msg('All Entities') : yext.msg('Select Entities');
      case folders:
        return asFilter ? yext.msg('All Folders') : yext.msg('Select Folders');
      case labels:
        return asFilter ? yext.msg('All Labels') : yext.msg('Select Labels');
      case entityTypes:
        return asFilter ? yext.msg('All Entity Types') : yext.msg('Select Entity Types');
    }
  }

  if (cart.total === 1) {
    const item = getFirstItem(cart);
    // TODO(amullings): Include sublabel?
    return item.label;
  }

  const usingEntities = items.includes(ItemTypes.ENTITIES);
  if (usingEntities && (cart.entityTypes.length > 0 || cart.entities.length > 0)) {
    return locationsOnly
      ? yext.msgn('1 Location', '{0} Locations', cart.total)
      : yext.msgn('1 Entity', '{0} Entities', cart.total);
  } else if (cart.folders.length > 0) {
    return yext.msgn('1 Folder', '{0} Folders', cart.total);
  } else if (cart.labels.length > 0) {
    return yext.msgn('1 Label', '{0} Labels', cart.total);
  } else if (cart.entityTypes.length > 0) {
    return yext.msgn('1 Entity Type', '{0} Entity Types', cart.total);
  }

  return '';
}

/**
 * @param {CartModel|SelectionModel} items list of items in the cart
   * @return {?} the
   * first item found in the cart or selection
   */
function getFirstItem(items) {
  for (const arr of [items.entityTypes, items.entities, items.folders, items.labels]) {
    if (arr.length) {
      return arr[0];
    }
  }
  return null;
}
